// web/src/layouts/BasicLayout/workbenchSurface.ts —— 统一工作台的界面切换助手。
// 工作台只有一个入口（/workbench），电话/在线是同一页面里的两种界面：
// - 跳转前把要展示的界面记到 sessionStorage（页面挂载时据此恢复，刷新不跳回电话）；
// - 同时广播界面切换事件，让顶栏渠道开关与已挂载的工作台立即跟随。
// 抽到独立文件是为了让 BasicLayout 保持单文件规模上限（frontend.md §9）。
import { WORKBENCH_SURFACE_EVENT, type WorkbenchSurface } from '../../api/shift';

/** 记住并广播工作台界面（surface=phone/online） */
export function enterWorkbenchSurface(surface: WorkbenchSurface) {
  try {
    sessionStorage.setItem('bcc-wb-surface', surface);
  } catch {
    /* 隐私模式不可写：忽略 */
  }
  window.dispatchEvent(new CustomEvent(WORKBENCH_SURFACE_EVENT, { detail: { surface } }));
}
